/** Report response shapes for the PM Reports dashboard. */

/** reports/leaveReport — feeds the "Attendance / Leaves" summary card. */
export interface LeaveReportSummary {
  userid?: string;
  leaveTaken?: number;
  wfhTaken?: number;
  workingDays?: number;
  attendance?: number;
  remainingLeaves?: number;
  percentage?: string | number;
  [key: string]: any;
}

/** reports/hoursReport — feeds the "Hours Worked" summary card. */
export interface HoursReportSummary {
  hours_worked?: number;
  hours_lapsed?: number;
  productivity?: number;
  [key: string]: any;
}

/** reports/projectReport — feeds the "Projects" summary card. */
export interface ProjectReportCounts {
  total_project?: string | number;
  inprogress_project?: string | number;
  onhold_project?: string | number;
  completed_project?: string | number;
  delete_project?: string | number;
}

export interface ProjectReportSummary {
  total_projects?: number | string;
  completed_projects?: number | string;
  inprogress_projects?: number | string;
  onhold_projects?: number | string;
  exceeded_projects?: number | string;
  completed_percentage?: number | string;
  inprogress_percentage?: number | string;
  onhold_percentage?: number | string;
  exceeded_percentage?: number | string;
  Counts?: ProjectReportCounts[];
  exceeded?: { ExceedCount?: string | number }[];
  percentage_Exceedtimeline?: number | string;
  [key: string]: any;
}

/** reports/CustomerReport — feeds the "Customers" summary card. */
export interface CustomerReportRow {
  project_type_id?: string | null;
  project_type_name?: string | null;
  project_count?: number | string;
}

/** Optional filters sent with the report endpoints. */
export interface ReportFilterParams {
  month?: string;
  type?: string;
  daterange?: string;
  range?: string;
  project_id?: string;
  project_track_id?: string;
  client_id?: string;
  status?: string;
  project_type?: string;
  industry?: string;
}

/** reports/pendingTimesheet — feeds the "Team's Timesheet" table. */
export interface PendingTimesheetRow {
  user_id?: string;
  usr_name?: string;
  usr_lastname?: string;
  usr_email?: string;
  [key: string]: any;
}
